import { EBroadcastTypes, SessionTypesEnum } from '@/types/session.types';
import { TBroadcastTypePickerOptions } from './broadcast-type-picker.types';

const getBroadcastTypeLabel = (broadcastType: TBroadcastTypePickerOptions) => {
  switch (broadcastType) {
    case EBroadcastTypes.greenroom:
      return 'Greenroom';
    case EBroadcastTypes.rtmps:
      return 'Encoder';
    case EBroadcastTypes.embed:
      return 'Embed';
    case EBroadcastTypes.fireside:
      return 'Meet Fireside';
    case SessionTypesEnum.breakoutRooms:
      return 'Breakouts';
    case SessionTypesEnum.onDemand:
      return 'On Demand';
    default:
      return 'Greenroom';
  }
};

export default getBroadcastTypeLabel;
